import Algolia from '../../search/services/Algolia';

export const SET_RESULTS = 'SET_RESULTS';

export const getResults = () => async (dispatch, getState) => {
  const { facets, page } = getState().search;

  const results = await Algolia.search('', {
      facetFilters: Object.keys(facets).reduce((acc, facetName) => {
        if (facets[facetName]) {
          acc.push(`${facetName}:${facets[facetName]}`)
        }
        return acc;
      }, []),
      optionalFilters: ['type:edito'],
      page,
    },
  );

  if (results) {
    dispatch({ type: SET_RESULTS, payload: results });
  }
}
